import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { cursoI } from 'src/app/shared/models/curso.interface';
import { CursoService } from 'src/app/servicios/curso.service';

@Component({
  selector: 'app-details-noticia',
  templateUrl: './details-noticia.component.html',
  styleUrls: ['./details-noticia.component.scss']
})
export class DetailsNoticiaComponent implements OnInit {

 //public noticia = {id:"1", titulo:"Primer noticia de prueba", imagen:"https://pbs.twimg.com/profile_images/1192149786503327744/l232oveZ_400x400.jpg", content:"aca va el contenido que tendria que ser largo, agrego texto para ver como queda eeeeeeeee re ge t etg etg etg et "}

 public link:any;
 public curso$:Observable<cursoI>;


 constructor(@Inject(DOCUMENT) document: any, private route:ActivatedRoute, private cursoSvc:CursoService) {
  
  }

  ngOnInit(): void {
    let id = this.route.snapshot.params.id;
    this.curso$ = this.cursoSvc.getOneCurso(id);
    //console.log(document.location.href);
    this.link = document.location.href;
  }

}
